module.exports = __webpack_public_path__ + "10e7c0388618d17032efba82e4d2b0cf.pdf";